























import moment from 'moment'
import { computed, defineComponent, SetupContext } from '@vue/composition-api'
import { QuestionnaireAnswerEntity } from '../../../../api/@types'
import { ReceiptSupplier, supplierName } from '@/types/receipt'

type Props = {
  questionnaireAnswers: QuestionnaireAnswerEntity[]
  loading: boolean
}

export default defineComponent({
  name: 'QuestionnaireAnswerTable',
  props: {
    questionnaireAnswers: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: Props, context: SetupContext) {
    const store = context.root.$store

    const headers = [
      { text: 'チェック日時', value: 'checkedAt' },
      { text: '回答ID', value: 'id' },
      { text: '回答日時', value: 'answeredAtDisplay' },
      { text: 'サービス名', value: 'supplier' },
      { text: 'アンケート名', value: 'questionnaireName' },
      { text: 'アンケート管理名', value: 'questionnaireNameAdmin' },
      { text: 'チェッカーステータス', value: 'checkerCheckStatus' },
      { text: '管理者ステータス', value: 'adminCheckStatus' },
      { text: 'リンク', value: 'edit' },
    ]

    const items = computed(() =>
      props.questionnaireAnswers.map(q => ({
        ...q,
        checkedAt: '未処理',
        supplier: supplierName(
          q.questionnaire.targetSupplier as ReceiptSupplier,
        ),
        questionnaireName: q.questionnaire.name,
        questionnaireNameAdmin: q.questionnaire.nameAdmin,
        checkerCheckStatus:
          q.checkerCheckStatus === 'non'
            ? '未処理'
            : q.checkerCheckStatus === 'ok'
            ? 'OK'
            : 'NG',
        adminCheckStatus:
          q.adminCheckStatus === 'non'
            ? '未処理'
            : q.adminCheckStatus === 'ok'
            ? 'OK'
            : 'NG',
        receiptId: q.receiptId,
        answeredAtDisplay: q.answeredAt
          ? moment(q.answeredAt).format('YYYY/MM/DD HH:mm')
          : '-',
      })),
    )

    const onClickEditButton = async (
      item: Record<string, string | boolean>,
    ) => {
      await store.dispatch(
        'questionnaireAnswer/getQuestionnaireAnswer',
        item.id,
      )
      if (Number(item.receiptId)) {
        await store.dispatch('questionnaireAnswer/getReceipt', item.receiptId)
      }
      context.root.$router.push('/questionnaire-answer').catch(() => {
        /*2連打した際のerrorを無視*/
      })
    }

    return { headers, moment, items, onClickEditButton }
  },
})
